Vue.component('accordion', {
    data: function () {
        return {
            activeTab: 1
        }
    },
});